import React, { useState } from "react";
import { Checkbox } from "antd";
import CommonModal from "../../components/Modal";
import { ModalProps } from "../../components/Modal/Modal.types";
import { Icon } from "Components";
import Alert from "PhishingManager/components/Alert";
import { useTranslation } from "react-i18next";

const ReRunModal: React.FC<ModalProps> = ({
    open,
    onClose,
    onConfirm,
}) => {
    const [checked, setChecked] = useState(false);
    const { t } = useTranslation();

    return (
        <CommonModal
            visible={open}
            confirmBtnDisabled={!checked}
            cancelText={t("phishingManager.reRunModal.cancelText")}
            modalTitle={t("phishingManager.reRunModal.title")}
            confirmText={t("phishingManager.reRunModal.confirmText")}
            parentClass="re-run-campaign-modal"
            iconType={null}
            onClose={onClose}
            onConfirm={onConfirm}
        >
            <div>{t("phishingManager.reRunModal.description")}</div>
            <div className="info-section">
                <span>{t("phishingManager.reRunModal.infoSection.title")}</span>
                <div className="info-preview">
                    <Icon type="envelope" />
                    <div className="info-preview-content">
                        <span className="title">
                            <strong>
                                {t("phishingManager.reRunModal.infoSection.senderWhitelist.title")}
                            </strong>
                        </span>
                        <span className="subTitle">
                            {t("phishingManager.reRunModal.infoSection.senderWhitelist.subtitle")}
                        </span>
                    </div>
                </div>
            </div>
            <Alert
                iconType="phishingManagerWarningModal"
                subtitle={t("phishingManager.reRunModal.alert.subtitle")}
            />
            <div className="checkbox-section">
                <Checkbox
                    checked={checked}
                    onChange={() => setChecked(!checked)}
                >
                    {t("phishingManager.reRunModal.checkbox.label")}
                </Checkbox>
            </div>
        </CommonModal>
    );
};

export default ReRunModal;